import React, { useEffect, useRef, useState } from 'react';
import { Popover } from 'antd';
import { apiHolder as api, apis } from 'api';
import ContactDetail from '@web-contact/component/Detail/detail';
import { useContactModel } from '@web-common/hooks/useContactModel';
import { getIn18Text } from 'api';
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const systemApi = api.api.getSystemApi();
const contactApi = api.api.requireLogicalApi(apis.contactApiImpl);
const accountApi = api.api.requireLogicalApi(apis.accountApiImpl);
const ItemCard = props => {
    var _a, _b, _c, _d, _e, _f, _g;
    const { contact, type, trigger, showAccount = true, children, originName = '', placement = 'bottomLeft', domName, onNotifyParent, disabled = false, curAccount = (_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id, customerLabel, handleVisible, isSelected, trInfo, isDetail = false, } = props;
    const _account = (_b = systemApi.getCurrentUser()) === null || _b === void 0 ? void 0 : _b.id;
    const contactId = (_c = contact === null || contact === void 0 ? void 0 : contact.contact) === null || _c === void 0 ? void 0 : _c.id;
    const email = ((_d = contact === null || contact === void 0 ? void 0 : contact.contact) === null || _d === void 0 ? void 0 : _d.hitQueryEmail) || ((_e = contact === null || contact === void 0 ? void 0 : contact.contact) === null || _e === void 0 ? void 0 : _e.accountName);
    const name = (_f = contact === null || contact === void 0 ? void 0 : contact.contact) === null || _f === void 0 ? void 0 : _f.contactName;
    const contactModel = useContactModel({
        email,
        contactId,
        isMainAccount: curAccount === _account,
        name,
        _account: curAccount,
    }) || contact;
    const domContainer = domName ? document.body : document.getElementById('mailboxModule') || document.body;
    const [visible, setVisible] = useState(false);
    const contactType = useRef('stranger');
    useEffect(() => {
        var _a, _b;
        if (contactModel) {
            if ((process.env.BUILD_ISEDM || process.env.BUILD_ISLINGHANG) && contactModel.customerOrgModel) {
                contactType.current = contactModel.customerOrgModel.role;
            }
            else if (((_a = contactModel === null || contactModel === void 0 ? void 0 : contactModel.contact) === null || _a === void 0 ? void 0 : _a.type) === 'personal') {
                contactType.current = 'personal';
            }
            else if (((_b = contactModel === null || contactModel === void 0 ? void 0 : contactModel.contact) === null || _b === void 0 ? void 0 : _b.type) === 'enterprise') {
                contactType.current = 'enterprise';
            }
        }
    }, [contactModel]);
    useEffect(() => {
        if (contactId && visible && contactType.current) {
            trackApi.track('waimao_mail_view_contactsDetailPage_contactType', { contactType: contactType.current });
        }
    }, [contactId, visible]);
    const renderCard = (model) => {
        var _a, _b, _c, _d, _e;
        let name = null;
        if (model) {
            const displayEmail = ((_a = model === null || model === void 0 ? void 0 : model.contact) === null || _a === void 0 ? void 0 : _a.type) === 'personal' ? email : contactApi.doGetModelDisplayEmail(model);
            if (curAccount === displayEmail) {
                const isThirdSubAccount = systemApi.getIsThirdSubAccountByEmailId(displayEmail);
                const displayEmail2 = isThirdSubAccount ? accountApi.getAgentEmailByEmail(displayEmail) : displayEmail;
                name = (React.createElement(React.Fragment, null,
                    React.createElement("span", { className: "u-card-theme", "data-test-id": "mail-head-name" }, getIn18Text('WO')),
                    showAccount ? (React.createElement("span", { className: "u-card-email", title: displayEmail },
                        "\u00A0\u00A0",
                        displayEmail2)) : null));
            }
            else if (((_b = model === null || model === void 0 ? void 0 : model.contact) === null || _b === void 0 ? void 0 : _b.type) !== 'external' && ((_c = model === null || model === void 0 ? void 0 : model.contact) === null || _c === void 0 ? void 0 : _c.contactName)) {
                name = (React.createElement(React.Fragment, null,
                    React.createElement("span", { className: "u-card-theme", "data-test-id": "mail-head-name", style: { minWidth: process.env.BUILD_ISEDM ? '25px' : 'auto' } }, ((_d = model === null || model === void 0 ? void 0 : model.contact) === null || _d === void 0 ? void 0 : _d.contactName) || originName),
                    showAccount && displayEmail ? (React.createElement("span", { className: "u-card-email", title: displayEmail, "data-test-id": "mail-head-email" },
                        "\u00A0\u00A0",
                        displayEmail)) : null));
            }
            else {
                name = (React.createElement(React.Fragment, null,
                    React.createElement("span", { className: "u-card-theme", "data-test-id": "mail-head-name", style: { minWidth: process.env.BUILD_ISEDM ? '25px' : 'auto' } }, originName || ((_e = model === null || model === void 0 ? void 0 : model.contact) === null || _e === void 0 ? void 0 : _e.contactName) || displayEmail),
                    showAccount && displayEmail ? (React.createElement("span", { className: "u-card-email", title: displayEmail },
                        "\u00A0\u00A0",
                        displayEmail)) : null));
            }
        }
        return name;
    };
    return disabled ? (React.createElement(React.Fragment, null, type === 'avatar' ? (children) : (React.createElement("div", { className: `u-card${isSelected ? ' u-card-selected' : ''}${!!isDetail ? ' u-card-detail' : ''}` },
        renderCard(contactModel),
        customerLabel ? customerLabel : null)))) : (React.createElement(Popover, { trigger: "click", zIndex: 1040, visible: visible, onVisibleChange: _visible => {
            setVisible(_visible);
            handleVisible && handleVisible(_visible);
        }, getPopupContainer: () => domContainer, overlayClassName: "u-detail-popup contact-mumber-popover", placement: placement, onClick: (e) => e.stopPropagation(), content: React.createElement(ContactDetail, { contact: contactModel, email: contactApi.doGetModelDisplayEmail(contactModel), contactId: (_g = contactModel === null || contactModel === void 0 ? void 0 : contactModel.contact) === null || _g === void 0 ? void 0 : _g.id, originName: originName, dividerLine: false, directSend: true, branch: true, toolipShow: true, containerClassName: "detail-read-container extheme", trigger: trigger, showClose: true, _account: curAccount, onNotifyParent: () => {
                onNotifyParent && onNotifyParent();
                setVisible(false);
            }, trInfo: trInfo }) }, type === 'avatar' ? (children) : (React.createElement("div", { className: `u-card${isSelected ? ' u-card-selected' : ''}${!!isDetail ? ' u-card-detail' : ''}` },
        renderCard(contactModel),
        customerLabel ? customerLabel : null))));
};
export default ItemCard;
